<ion-item lines='none'>
    <ion-toggle [formControl]="$any(formControl)" [id]="key">{{to.label}}
        <ion-text *ngIf="field.ta_validators?.required || field.ta_validators?.checkboxRequired" color="danger">*
        </ion-text>
    </ion-toggle>
</ion-item>